export default __webpack_public_path__ + "static/media/interior_color.068d187f.svg";